import { Outlet } from 'react-router-dom';
import { MobileFrame } from '@/components/shared/MobileFrame';
import { DevBar } from '@/components/shared/DevBar';
import { OfflineBanner } from '@/components/shared/OfflineBanner';
import { ModeBanner } from '@/components/shared/ModeBanner';
import { ToastViewport } from '@/components/ui/toast';

export function AuthLayout() {
    return (
        <MobileFrame>
            <DevBar />
            <div className="flex flex-col min-h-dvh md:h-[852px] overflow-y-auto no-scrollbar">
                <ModeBanner />
                <OfflineBanner />
                <Outlet />
            </div>
            <ToastViewport />
        </MobileFrame>
    );
}
